import React from "react";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";
import TEXT from "../../../utils/text/pnudBook.json";
import SurveyGraphSection from "../../reusable/SurveyGraphSection/SurveyGraphSection";
import CardSurveys from "../../reusable/CardSurveys";
import data from "../../../utils/PNUD/acceptance.json";
import { TOOLTIP_STYLE } from "../../../utils/constants/graphConfigs";
import { getCountryName } from "../../../utils/constants/nameCountry";
import createPNUDTitle from "../../../utils/functions/createPNUDTitle";
import { formatNumber } from "../../../utils/functions/formatNumber";

export default function PNUDAcceptance({ textPlacement }) {
  const { language } = useCurrentLanguage();

  function AcceptanceGraph() {
    const options = {
      color: ["#253c59", "#bf8d30"],
      xAxis: {
        type: "value",
        splitLine: {
          show: false,
        },
        axisLine: {
          show: true,
        },
        axisLabel: {
          formatter: "{value}pp",
        },
      },
      yAxis: {
        type: "category",
        data: data["yAxisData"].map((country) =>
          getCountryName(country, language, true)
        ),
        splitLine: {
          show: true,
        },
        axisLabel: {
          margin: 15,
        },
      },
      tooltip: {
        trigger: "axis",
        valueFormatter: function (value) {
          if (value === 0.15) return "0.0pp";
          return formatNumber(value.toFixed(1), language) + "pp";
        },
        ...TOOLTIP_STYLE,
      },
      legend: {
        data: ["Informativo", "Emotivo"],
        left: "center",
        bottom: 10,
      },
      series: [
        {
          name: "Informativo",
          symbolSize: 20,
          data: data["data"]["informative"],
          type: "scatter",
        },
        {
          name: "Emotivo",
          symbolSize: 20,
          data: data["data"]["emotive"],
          type: "scatter",
        },
      ],
      grid: {
        left: "23%",
        bottom: "16%",
      },
    };

    return (
      <>
        <div className="pnud-graph-content">
          <CardSurveys options={options} isGraphLeft={false} />
        </div>
        <div className="pnud-graph-note">{TEXT["notePP"][language]}</div>
      </>
    );
  }

  return (
    <SurveyGraphSection
      graphID={"pnud-acceptance"}
      textPlacement={textPlacement}
      title={createPNUDTitle(TEXT["acceptance"]["title"], language)}
      description={TEXT["acceptance"]["description"][language]}
      language={language}
      graphComponent={<AcceptanceGraph />}
      source={TEXT["source"][language]}
      titleExtraPadding={true}
    />
  );
}
